module.exports = __webpack_public_path__ + "img/bg-2.280a8ff1.jpeg";